module.exports = "/_next/static/images/CacGuide2023-8542fdfb4a02bda857e9d380b64b7881.png";